<div class="flex flex-col gap-10 contents">
    @for (documentType of documentTypes(); track documentType.id) {
        @if ((!showOnlyType() || documentType.id === showOnlyType()) && (!excludeType() || documentType.id !== excludeType())) {
            <div class="space-y-6 bg-white p-4 rounded-button shadow-sm border border-app-primary-10 m-4 h-fit">
            <div class="text-app-primary-20 font-semibold border-b border-app-primary-10/10 pb-2">
                {{ documentType.description }}
            </div>

            <!-- Dateiliste -->
            <div class="grid grid-cols-1 gap-4">
                @if (isLoadingFiles()) {
                    <div class="flex flex-col items-center justify-center py-12 gap-4">
                        <i class="fa-solid fa-circle-notch fa-spin text-4xl text-app-primary-10"></i>
                        <p class="text-app-secondary-10 animate-pulse">Lade Dokumente...</p>
                    </div>
                } @else {
                    @for (file of (documentType.id === 'medication-plan' ? medicationFiles() :
                                  documentType.id === 'doctor-letters' ? doctorLetterFiles() :
                                  documentType.id === 'documents' ? documentFiles() :
                                  documentType.id === 'id-documents' ? idFiles() :
                                  (documentType.id === 'uploads' || documentType.id === 'other') ? uploadedFiles() : []); track file.id) {
                        @if (documentType.id === 'id-documents') {
                            <!-- Spezielle Anzeige für Ausweisdokumente mit Vorschau -->
                            <div class="bg-white rounded-lg border border-app-primary-10/10 shadow-sm overflow-hidden flex flex-col">
                                <div class="p-3 bg-app-background-20/50 border-b border-app-primary-10/10 flex justify-between items-center">
                                    <span class="text-xs font-medium text-app-primary-20">
                                        @if (file.fileName.includes('back')) {
                                            Rückseite des Personalausweises
                                        } @else {
                                            Vorderseite des Personalausweises
                                        }
                                    </span>
                                    <div class="flex items-center gap-2">
                                        <button class="w-7 h-7 flex items-center justify-center rounded-full bg-white text-app-primary-10 shadow-sm hover:bg-app-primary-10 hover:text-white transition-colors"
                                                (click)="triggerDownload(file)" title="Download">
                                            <i class="fa-solid fa-download text-[10px]"></i>
                                        </button>
                                        <button class="w-7 h-7 flex items-center justify-center rounded-full bg-white text-red-500 shadow-sm hover:bg-red-500 hover:text-white transition-colors"
                                                (click)="triggerDelete(file.id)" title="Löschen">
                                            <i class="fa-solid fa-times text-[10px]"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="relative aspect-video bg-gray-100 flex items-center justify-center overflow-hidden">
                                    @if (file.base46) {
                                        <img [src]="'data:image/png;base64,' + file.base46" alt="Vorschau" class="w-full h-full object-cover">
                                    } @else {
                                        <div class="flex flex-col items-center gap-2 text-app-secondary-10">
                                            <i class="fa-solid fa-image text-2xl opacity-20"></i>
                                            <span class="text-[10px]">Keine Vorschau verfügbar</span>
                                        </div>
                                    }
                                </div>
                                <div class="p-2 text-[9px] text-app-secondary-10 bg-white">
                                    Hochgeladen am {{ file.uploadedAt | date: 'dd.MM.yyyy HH:mm' }} Uhr
                                </div>
                            </div>
                        } @else {
                            <div class="bg-app-background-20 rounded-lg border border-app-primary-10/10 shadow-sm overflow-hidden">
                                <div class="p-4 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                                    <div class="flex flex-col gap-1">
                                        <span class="text-sm font-medium text-app-primary-20">{{ file.fileName }}</span>
                                        <span class="text-[10px] text-app-secondary-10">
                                            Hochgeladen von {{ file.uploadedBy.title ? file.uploadedBy.title + ' ' : '' }}{{ file.uploadedBy.firstName }} {{ file.uploadedBy.lastName }} am {{ file.uploadedAt | date: 'dd.MM.yyyy HH:mm' }} Uhr
                                        </span>
                                    </div>
                                    <div class="flex items-center gap-2">
                                        @if (!isDoctor()) {
                                            <button class="w-8 h-8 flex items-center justify-center rounded-full bg-app-primary-10/10 text-app-primary-10 hover:bg-app-primary-10 hover:text-white transition-colors"
                                                    (click)="openPermissions(file.id)" title="Berechtigungen">
                                                <i class="fa-solid fa-share text-xs"></i>
                                            </button>
                                        }
                                        <button class="w-8 h-8 flex items-center justify-center rounded-full bg-app-primary-10/10 text-app-primary-10 hover:bg-app-primary-10 hover:text-white transition-colors"
                                                (click)="triggerDownload(file)" title="Download">
                                            <i class="fa-solid fa-download text-xs"></i>
                                        </button>
                                        <button class="w-8 h-8 flex items-center justify-center rounded-full bg-red-100 text-red-600 hover:bg-red-500 hover:text-white transition-colors"
                                                (click)="triggerDelete(file.id)" title="Löschen">
                                            <i class="fa-solid fa-times text-xs"></i>
                                        </button>
                                    </div>
                                </div>

                                <!-- Berechtigungs-Bereich (ausklappbar) -->
                                @if (openPermissionsId() == file.id) {
                                    <div class="px-4 pb-4 pt-2 border-t border-app-primary-10/5 bg-app-background-20/30 animate-fade-in">
                                        <div class="flex justify-between items-center mb-3">
                                            <span class="text-xs font-medium text-app-primary-20">Berechtigungen verwalten</span>
                                            <button (click)="openPermissions('')" class="text-app-secondary-10 hover:text-app-primary-10">
                                                <i class="fa-solid fa-times text-xs"></i>
                                            </button>
                                        </div>

                                        @if (file.permissionsGranted && file.permissionsGranted.length > 0) {
                                            <div class="space-y-2 mb-4">
                                                @for (granted of file.permissionsGranted; track granted.id) {
                                                    <div class="flex justify-between items-center p-2 bg-white rounded border border-app-primary-10/5">
                                                        <span class="text-xs">
                                                            {{ granted.doctor.title ? granted.doctor.title + ' ' : '' }}{{ granted.doctor.firstName }} {{ granted.doctor.lastName }}
                                                        </span>
                                                        <button class="text-red-500 hover:text-red-600 p-1" (click)="deletePermission(granted.id)" title="Berechtigung entziehen">
                                                            <i class="fa-solid fa-times text-[10px]"></i>
                                                        </button>
                                                    </div>
                                                }
                                            </div>
                                        } @else {
                                            <p class="text-[10px] text-app-secondary-10 mb-4 italic">Noch nicht mit Ärzten geteilt.</p>
                                        }

                                        <div class="flex justify-center">
                                            <button class="btn primary-button !py-1 !px-3 !text-[10px] flex items-center gap-2" (click)="openPermissionModal(file)">
                                                <i class="fa-solid fa-plus"></i>
                                                Mit einem Arzt teilen
                                            </button>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    } @empty {
                        <div class="p-6 bg-app-background-20/50 rounded-lg border border-dashed border-app-primary-10/10 text-center">
                            <p class="text-xs text-app-secondary-10">Keine Dokumente in dieser Kategorie vorhanden.</p>
                        </div>
                    }
                }
            </div>

            <!-- Upload-Feld -->
            <div class="mt-4">
                <app-file-upload (fileSelected)="triggerFileUpload($event, documentType.id)"
                                 [useBase64Upload]="false"
                                 class="bg-app-background-20 rounded-lg p-4 border-2 border-dashed border-app-primary-10/10 block"></app-file-upload>
            </div>
        </div>
    }
}
</div>
